import { Button } from './ui/button';
import { Cake, Star, Trophy } from 'lucide-react';
import {
  Dialog, DialogContent,
} from './ui/dialog';

const GYM_MESSAGES = [
  "May your lifts be heavy and your birthday gains legendary!",
  "Another year stronger. Keep crushing it!",
  "Time to PR your birthday celebrations. Let's go!",
  "Stronger than yesterday, more celebrated than ever!",
];

export default function MyBirthdayPopup({ open, onDismiss, user }) {
  if (!user) return null;
  const message = GYM_MESSAGES[new Date().getDate() % GYM_MESSAGES.length];

  return (
    <Dialog open={open} onOpenChange={onDismiss}>
      <DialogContent
        className="bg-[#09090B] border-[#CCFF00]/40 max-w-md overflow-hidden"
        data-testid="my-birthday-popup"
      >
        {/* Decorative top bar */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#CCFF00]/0 via-[#CCFF00] to-[#CCFF00]/0" />

        {/* Stars decoration */}
        <div className="absolute top-4 left-4 opacity-30">
          <Star className="w-3 h-3 text-[#CCFF00] fill-[#CCFF00]" />
        </div>
        <div className="absolute top-6 right-8 opacity-20">
          <Star className="w-4 h-4 text-[#CCFF00] fill-[#CCFF00]" />
        </div>
        <div className="absolute top-3 right-4 opacity-40">
          <Star className="w-2 h-2 text-[#CCFF00] fill-[#CCFF00]" />
        </div>

        <div className="pt-6 pb-2 text-center space-y-5">
          {/* Icon cluster */}
          <div className="flex items-center justify-center gap-3">
            <Trophy className="w-6 h-6 text-[#CCFF00]/50" />
            <div className="bg-[#CCFF00]/10 border border-[#CCFF00]/30 p-4 rounded-full">
              <Cake className="w-12 h-12 text-[#CCFF00]" />
            </div>
            <Trophy className="w-6 h-6 text-[#CCFF00]/50" />
          </div>

          {/* Headline */}
          <div>
            <p className="text-xs text-[#CCFF00] uppercase tracking-[0.3em] font-semibold mb-1">
              R&R Elite Fitness celebrates
            </p>
            <h2 className="text-4xl font-heading font-black uppercase text-[#FAFAFA] leading-none">
              Happy
            </h2>
            <h2 className="text-4xl font-heading font-black uppercase text-[#CCFF00] leading-none">
              Birthday!
            </h2>
          </div>

          {/* Name card */}
          <div className="bg-[#CCFF00]/5 border border-[#CCFF00]/20 rounded-sm py-4 px-6 mx-2">
            <p className="text-2xl font-heading font-black uppercase text-[#FAFAFA]">
              {user.name}
            </p>
            <p className="text-sm text-[#A1A1AA] mt-2 leading-snug">
              {message}
            </p>
          </div>

          {/* Dismiss */}
          <div className="pt-2 px-2">
            <Button
              onClick={onDismiss}
              data-testid="my-birthday-dismiss"
              className="w-full bg-[#CCFF00] text-[#09090B] font-bold uppercase tracking-wider hover:bg-[#b8e600] rounded-sm"
            >
              Let's Train!
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
